import request from '@/util/request';

export const getFeePayList = (returnId) => {
  return request({
    url: '/api/feeBack/feereturn/feePayListForAudit',
    method: 'get',
    params: {
      returnId,
    },
  });
};

export const auditFeeReturn = (params) => {
  return request({
    url: '/api/feeBack/feereturn/audit',
    method: 'post',
    data: params,
  });
};

export const auditTwice = (params) => {
  return request({
    url: '/api//feeBack/feereturn/auditTwice',
    method: 'post',
    data: params,
  });
};
